import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  generalMessagesItemCount: 0,
  worklistClaimsItemCount: 0,
  worklistRisksItemCount: 0,
  getWorklistsItemCountStatus: IDLE
};

const worklistsSlice = createSlice({
  name: 'worklists',
  initialState,
  reducers: {
    getWorklistsItemCount(state) {
      state.getWorklistsItemCountStatus = LOADING;
    },
    getWorklistsItemCountSucceeded(state, action) {
      state.generalMessagesItemCount = action.payload?.general;
      state.worklistClaimsItemCount = action.payload?.claims;
      state.worklistRisksItemCount = action.payload?.risks;
      state.getWorklistsItemCountStatus = SUCCEEDED;
    },
    getWorklistsItemCountFailed(state) {
      state.getWorklistsItemCountStatus = FAILED;
    }
  }
});

export const { getWorklistsItemCount, getWorklistsItemCountSucceeded, getWorklistsItemCountFailed } =
  worklistsSlice.actions;

export default worklistsSlice.reducer;
